import { useEffect, useState } from "react";

/**
 * This hook returns the component's mounted state.
 */
export const useIsMounted = () => {
  const [state, setState] = useState(false);

  useEffect(() => {
    setState(true);
  }, []);

  return state;
};
